import { z } from 'zod';

export const AdminAnalyticsTotals = z.object({
  members: z.number(),
  matches: z.number(),
  relationships: z.number(),
});
export type AdminAnalyticsTotals = z.infer<typeof AdminAnalyticsTotals>;

export const AdminAnalyticsDay = z.object({
  date: z.string(),
  newUsers: z.number(),
  sessions: z.number(),
});
export type AdminAnalyticsDay = z.infer<typeof AdminAnalyticsDay>;

export const AdminAnalytics7d = z.object({
  range: z.object({ from: z.string(), to: z.string() }),
  userCount: z.number(),
  newUsers: z.number(),
  activeUsers: z.number(),
  sessionsCreated: z.number(),
  totals: AdminAnalyticsTotals,
  daily: z.array(AdminAnalyticsDay),
});
export type AdminAnalytics7d = z.infer<typeof AdminAnalytics7d>;

export const AdminAnalytics7dResponse = AdminAnalytics7d;
export type AdminAnalytics7dResponse = z.infer<typeof AdminAnalytics7dResponse>;

// ── Nutzeraktivität ──────────────────────────────────────────
// Basis ist das Tages-Rollup UserActivityDay (jeder authentifizierte API-Aufruf
// zählt als Interaktion) — nicht die Session-Erstellung, die nur Logins sieht.
export const ActivityUserRow = z.object({
  id: z.string(),
  label: z.string(),
  email: z.string(),
  createdAt: z.string(),
  lastSeenAt: z.string().nullable(),
  /** An wie vielen Tagen im Zeitraum der Nutzer aktiv war. */
  activeDays: z.number(),
  /** Interaktionen (API-Aufrufe) im Zeitraum. */
  requests: z.number(),
});
export type ActivityUserRow = z.infer<typeof ActivityUserRow>;

export const ActivityDay = z.object({
  date: z.string(),
  activeUsers: z.number(),
  requests: z.number(),
  newUsers: z.number(),
});
export type ActivityDay = z.infer<typeof ActivityDay>;

export const ActivityResponse = z.object({
  range: z.object({ from: z.string(), to: z.string(), days: z.number() }),
  /** Nutzer mit Aktivität in den letzten 5 Minuten. */
  onlineNow: z.number(),
  activeToday: z.number(),
  active7d: z.number(),
  requestsToday: z.number(),
  daily: z.array(ActivityDay),
  byUser: z.array(ActivityUserRow),
});
export type ActivityResponse = z.infer<typeof ActivityResponse>;

// ── KI-Kosten ────────────────────────────────────────────────
const AiCostBucket = z.object({
  key: z.string(), // Feature-Name, Modell-ID oder User-Label
  calls: z.number(),
  inputTokens: z.number(),
  outputTokens: z.number(),
  costUsd: z.number(),
});
export type AiCostBucket = z.infer<typeof AiCostBucket>;

export const AiCostsResponse = z.object({
  range: z.object({ from: z.string(), to: z.string(), days: z.number() }),
  totals: z.object({
    calls: z.number(),
    inputTokens: z.number(),
    outputTokens: z.number(),
    costUsd: z.number(),
  }),
  byFeature: z.array(AiCostBucket),
  byModel: z.array(AiCostBucket),
  byUser: z.array(AiCostBucket),
  daily: z.array(z.object({ date: z.string(), costUsd: z.number(), calls: z.number() })),
});
export type AiCostsResponse = z.infer<typeof AiCostsResponse>;
